<template>
  <div
    id="data-container"
    class="date-container i-text-body-2 i-text-neutral-110"
  >
    <info-tooltip
      title="Date Range Details"
      subtitle="The date range refers to the earliest and latest date across all bank statements uploaded."
    ></info-tooltip>
    <div class="i-ml-4">
      <span v-if="hasDates" data-testid="credit-header-date">
        {{ formatDates() }}
      </span>
      <span v-else data-testid="credit-header-fallback"
        >No date range available</span
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import InfoTooltip from '@/shared/components/InfoTooltip';

const DATE_FORMAT = 'MMM DD, YYYY';

export default {
  components: {
    InfoTooltip,
  },
  props: {
    type: {
      type: String,
      default: 'regular',
    },
  },
  computed: {
    ...mapState({
      credit: 'credit',
    }),

    hasDates() {
      return !!this.startDate() && !!this.endDate();
    },
  },
  methods: {
    startDate() {
      return this.type === 'granular'
        ? this.credit.granularInsights.transactionsByTimePeriod?.start_date
        : this.credit.startDate;
    },
    endDate() {
      return this.type === 'granular'
        ? this.credit.granularInsights.transactionsByTimePeriod?.end_date
        : this.credit.endDate;
    },
    formatDates() {
      return `${moment(this.startDate()).format(DATE_FORMAT)} - ${moment(
        this.endDate(),
      ).format(DATE_FORMAT)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.date-container {
  display: flex;
  align-items: center;
}
</style>
